import { useEffect, useState } from "react";

/** Vrai sur grand écran (≥ 900 px) : bascule automatique vers la disposition bureau. */
export function useIsDesktop(): boolean {
  const query = "(min-width: 900px)";
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia?.(query).matches,
  );
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia(query);
    const h = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  return isDesktop;
}
